import React from "react";
import useScrollPosition from "@react-hook/window-scroll";

function UpButtonResults(props) {
  const onClickHandler = () => {
    // TimeOut чтобы анимация успела проиграть
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 200);
  };
  const scrollY = useScrollPosition(30);
  return (
    <div
      className={scrollY > 1800 ? "results-up-button-wrapper" : "not-display"}
      style={{ marginRight: `${props.marginRight}` }}
    >
      <div className="results-up-button" onClick={onClickHandler}>
        Вверх <i className="arrow up"></i>
      </div>
    </div>
  );
}

export default UpButtonResults;
